import { COMPARADOR_SET_ITEMS_TO_COMPARE_SUCCESS } from './constants'
import initialState from './initialState'
import { cloneDeep } from 'lodash'

export function setItemsToCompare(data, index) {
    return {
        index,
        type: COMPARADOR_SET_ITEMS_TO_COMPARE_SUCCESS,
        data: data
    }
}

export function reducer(state = initialState, action) {
    const { index, data, type } = action

    if (type === COMPARADOR_SET_ITEMS_TO_COMPARE_SUCCESS) {
        const schema = cloneDeep(state.schema)
        schema[index].dataSelected = data
        return {
            ...state,
            schema,
            cardIndexMobile: index
        }
    } else {
        return state
    }

}
